import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING } from '../Utils/Constants';
const sReservationControllerEndpoint = 'Reservation';


export class ReservationAPI {

  getReservationsData(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '', salesChannelsIds = []) {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (salesChannelsIds)
      params.salesChannelsFilter = salesChannelsIds;
    return axios.get(getBackendURL() + sReservationControllerEndpoint + '/GetCarsAvailableForReservation', { params });
  }

  getEffectiveReservationsList(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sReservationControllerEndpoint + '/GetEffectiveReservationsList', { params });
  }

  getOnHoldReservationsList(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sReservationControllerEndpoint + '/GetOnHoldReservationsList', { params });
  }

  getHistoricalReservations(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sReservationControllerEndpoint + '/GetHistoricalReservationsList', { params });
  }

  getReservationsByHash(featuresHash, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      featuresHash: featuresHash,
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sReservationControllerEndpoint + '/GetReservationsByHash', { params });
  }

  getReservationsBySimilarity(l4Id, page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      l4Id: l4Id,
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sReservationControllerEndpoint + '/GetReservationsBySimilarity', { params });
  }

  createReservation(dto) {
    return axios.post(getBackendURL() + sReservationControllerEndpoint + '/CreateReservation', dto);
  }

  extendReservation(dto) {
    return axios.put(getBackendURL() + sReservationControllerEndpoint + '/ExtendReservation', dto);
  }

  cancelReservation(dto) {
    return axios.put(getBackendURL() + sReservationControllerEndpoint + '/CancelReservation', dto);
  }

}

export default ReservationAPI


// WEBPACK FOOTER //
// ./src/API/ReservationAPI.js